import React from 'react';
export function WordmarkOptions2() {
  return <div className="min-h-screen bg-slate-50 py-16 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-1001">
      <div className="max-w-7xl mx-auto" data-id="element-1002">
        <div className="text-center mb-16" data-id="element-1003">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-1004">
            Wordmark Explorations — Round 2
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-1005">
            Refined variations based on your 4 favorites: Bold Gradient,
            Lowercase Tech, Superscript, and Dark Glow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1006">
          {/* --- Riffs on #1 (Bold Uppercase + Gradient AI) --- */}

          {/* 1. Blue-to-Purple Gradient */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1007">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1008">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1009">
                1. Blue-to-Purple Gradient
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1010">
                Riff on #1 / Clean Shift
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1011">
              <div className="flex items-baseline" data-id="element-1012">
                <span className="text-3xl font-black text-slate-900 tracking-tighter uppercase" data-id="element-1013">
                  SWEDENMARK
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 ml-1" data-id="element-1014">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 2. Solid Emerald AI + Underline */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1015">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1016">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1017">
                2. Solid Emerald + Underline
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1018">
                Riff on #1 / Structural
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1019">
              <div className="flex items-baseline" data-id="element-1020">
                <span className="text-3xl font-black text-slate-900 tracking-tighter uppercase" data-id="element-1021">
                  SWEDENMARK
                </span>
                <div className="flex flex-col ml-1" data-id="element-1022">
                  <span className="text-3xl font-black text-emerald-500 leading-none" data-id="element-1023">
                    AI
                  </span>
                  <div className="h-[3px] w-full bg-emerald-500 mt-1" data-id="element-1024"></div>
                </div>
              </div>
            </div>
          </div>

          {/* 3. Bar Separator */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1025">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1026">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1027">
                3. Bar Separator
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1028">
                Riff on #1 / Separated
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1029">
              <div className="flex items-center" data-id="element-1030">
                <span className="text-3xl font-black text-slate-900 tracking-tighter uppercase" data-id="element-1031">
                  SWEDENMARK
                </span>
                <span className="text-3xl font-light text-slate-300 mx-2 pb-1" data-id="element-1032">
                  |
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500" data-id="element-1033">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* --- Riffs on #3 (Lowercase Tech) --- */}

          {/* 4. Lowercase Gradient AI */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1034">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1035">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1036">
                4. Lowercase Gradient AI
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1037">
                Riff on #3 / Bold Accent
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1038">
              <div className="flex items-baseline" data-id="element-1039">
                <span className="text-3xl font-bold text-slate-800 tracking-tight lowercase" data-id="element-1040">
                  swedenmark
                </span>
                <span className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 ml-1 lowercase" data-id="element-1041">
                  ai
                </span>
                <div className="w-2 h-2 rounded-full bg-purple-500 ml-1 mb-1" data-id="element-1042"></div>
              </div>
            </div>
          </div>

          {/* 5. Dot Separator */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1043">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1044">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1045">
                5. Dot Separator
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1046">
                Riff on #3 / Balanced
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1047">
              <div className="flex items-center" data-id="element-1048">
                <span className="text-3xl font-semibold text-slate-800 tracking-tight lowercase" data-id="element-1049">
                  swedenmark
                </span>
                <div className="w-1.5 h-1.5 rounded-full bg-blue-500 mx-2 mt-1" data-id="element-1050"></div>
                <span className="text-3xl font-bold text-blue-600 lowercase" data-id="element-1051">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* 6. Domain Style */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1052">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1053">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1054">
                6. Domain Style
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1055">
                Riff on #3 / URL Vibe
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1056">
              <div className="flex items-baseline" data-id="element-1057">
                <span className="text-3xl font-bold text-slate-800 tracking-tight lowercase" data-id="element-1058">
                  swedenmark
                </span>
                <span className="text-3xl font-bold text-blue-500 lowercase" data-id="element-1059">
                  .ai
                </span>
              </div>
            </div>
          </div>

          {/* --- Riffs on #6 (Superscript) --- */}

          {/* 7. Gradient Superscript */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1060">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1061">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1062">
                7. Gradient Superscript
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1063">
                Riff on #6 / Vibrant
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1064">
              <div className="flex items-start" data-id="element-1065">
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-1066">
                  SWEDENMARK
                </span>
                <span className="text-xs font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 ml-0.5 mt-1" data-id="element-1067">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 8. Superscript + Dot */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1068">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1069">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1070">
                8. Superscript + Dot
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1071">
                Riff on #6 / Punctuation
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1072">
              <div className="flex items-start" data-id="element-1073">
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-1074">
                  SWEDENMARK
                </span>
                <div className="flex items-baseline ml-0.5 mt-1" data-id="element-1075">
                  <span className="text-sm font-black text-blue-600" data-id="element-1076">AI</span>
                  <div className="w-1 h-1 rounded-full bg-blue-600 ml-0.5" data-id="element-1077"></div>
                </div>
              </div>
            </div>
          </div>

          {/* 9. Mixed Case Superscript */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1078">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1079">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1080">
                9. Mixed Case Superscript
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1081">
                Riff on #6 / Approachable
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1082">
              <div className="flex items-start" data-id="element-1083">
                <span className="text-3xl font-bold text-slate-900 tracking-tight" data-id="element-1084">
                  Swedenmark
                </span>
                <span className="text-xs font-black text-blue-600 ml-0.5 mt-1.5" data-id="element-1085">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* --- Riffs on #12 (Dark Mode Glow) --- */}

          {/* 10. Purple Glow */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1086">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1087">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1088">
                10. Purple Glow
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1089">
                Riff on #12 / Lowercase
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-[#0f1729] relative overflow-hidden" data-id="element-1090">
              <div className="absolute w-32 h-32 bg-purple-500/20 rounded-full blur-2xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-1091"></div>
              <div className="flex items-baseline relative z-10" data-id="element-1092">
                <span className="text-2xl font-light text-white tracking-wide lowercase" data-id="element-1093">
                  swedenmark
                </span>
                <span className="text-2xl font-black text-purple-400 ml-1 lowercase drop-shadow-[0_0_10px_rgba(192,132,252,0.8)]" data-id="element-1094">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* 11. Emerald Glow Uppercase */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1095">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1096">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1097">
                11. Emerald Glow Uppercase
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1098">
                Riff on #12 / Bold
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-[#0f1729] relative overflow-hidden" data-id="element-1099">
              <div className="absolute w-32 h-32 bg-emerald-500/20 rounded-full blur-2xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-1100"></div>
              <div className="flex items-baseline relative z-10" data-id="element-1101">
                <span className="text-2xl font-bold text-white tracking-tight uppercase" data-id="element-1102">
                  SWEDENMARK
                </span>
                <span className="text-2xl font-black text-emerald-400 ml-1 uppercase drop-shadow-[0_0_8px_rgba(52,211,153,0.8)]" data-id="element-1103">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 12. Dual Glow */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1104">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1105">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1106">
                12. Dual Glow
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1107">
                Riff on #12 / Dominant AI
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-[#0f1729] relative overflow-hidden" data-id="element-1108">
              <div className="absolute w-24 h-24 bg-blue-500/20 rounded-full blur-xl top-1/2 left-1/3 transform -translate-x-1/2 -translate-y-1/2" data-id="element-1109"></div>
              <div className="absolute w-24 h-24 bg-purple-500/20 rounded-full blur-xl top-1/2 right-1/4 transform translate-x-1/2 -translate-y-1/2" data-id="element-1110"></div>
              <div className="flex items-center relative z-10" data-id="element-1111">
                <span className="text-xl font-light text-slate-300 tracking-widest lowercase" data-id="element-1112">
                  swedenmark
                </span>
                <span className="text-4xl font-black text-white ml-2 uppercase drop-shadow-[0_0_12px_rgba(255,255,255,0.4)]" data-id="element-1113">
                  AI
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ---- Large Showcases ---- */}

        {/* Enlarged #1: Blue-to-Purple Gradient */}
        <div className="mt-20 mb-16" data-id="element-1114">
          <div className="text-center mb-6" data-id="element-1115">
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1116">
              #1 — Blue-to-Purple Gradient (Enlarged)
            </h2>
            <p className="text-sm text-slate-500 mt-1" data-id="element-1117">Large-format view</p>
          </div>
          <div className="bg-white rounded-2xl shadow-md border border-slate-200 overflow-hidden" data-id="element-1118">
            <div className="py-24 px-12 flex items-center justify-center" data-id="element-1119">
              <div className="flex items-baseline" data-id="element-1120">
                <span className="text-7xl sm:text-8xl md:text-9xl font-black text-slate-900 tracking-tighter uppercase leading-none" data-id="element-1121">
                  SWEDENMARK
                </span>
                <span className="text-7xl sm:text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 ml-2 leading-none" data-id="element-1122">
                  AI
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* #6 Variant: Domain Style with Blue-to-Purple Gradient on .ai */}
        <div className="mb-16" data-id="element-1123">
          <div className="text-center mb-6" data-id="element-1124">
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1125">
              #6 Variant — Domain Style with Gradient
            </h2>
            <p className="text-sm text-slate-500 mt-1" data-id="element-1126">
              ".ai" in blue-to-purple gradient
            </p>
          </div>
          <div className="bg-white rounded-2xl shadow-md border border-slate-200 overflow-hidden" data-id="element-1127">
            <div className="py-24 px-12 flex items-center justify-center" data-id="element-1128">
              <div className="flex items-baseline" data-id="element-1129">
                <span className="text-7xl sm:text-8xl md:text-9xl font-bold text-slate-800 tracking-tight lowercase leading-none" data-id="element-1130">
                  swedenmark
                </span>
                <span className="text-7xl sm:text-8xl md:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 lowercase leading-none" data-id="element-1131">
                  .ai
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* ---- Dot Separator: Tight (Refined) ---- */}

        <div className="mt-20 mb-8" data-id="element-1132">
          <div className="text-center mb-10" data-id="element-1133">
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1134">
              Dot Separator — Tight (Refined)
            </h2>
            <p className="text-sm text-slate-500 mt-1" data-id="element-1135">
              Dot lowered to x-height center — white &amp; transparent
              backgrounds
            </p>
          </div>

          {/* White Background */}
          <div className="bg-white rounded-2xl shadow-md border border-slate-200 overflow-hidden mb-6" data-id="element-1136">
            <div className="px-4 py-2 border-b border-slate-100 bg-slate-50/50" data-id="element-1137">
              <h3 className="text-sm font-semibold text-slate-700" data-id="element-1138">
                White Background
              </h3>
            </div>
            <div className="py-20 px-12 flex items-center justify-center bg-white" data-id="element-1139">
              <div className="flex items-center" data-id="element-1140">
                <span className="text-7xl sm:text-8xl md:text-9xl font-semibold text-slate-800 tracking-tight lowercase leading-none" data-id="element-1141">
                  swedenmark
                </span>
                <div className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 mx-3 sm:mx-4 translate-y-[12%]" data-id="element-1142"></div>
                <span className="text-7xl sm:text-8xl md:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 lowercase leading-none" data-id="element-1143">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* Transparent Background */}
          <div className="rounded-2xl shadow-md border border-slate-200 overflow-hidden mb-6" data-id="element-1144">
            <div className="px-4 py-2 border-b border-slate-100 bg-slate-50/50" data-id="element-1145">
              <h3 className="text-sm font-semibold text-slate-700" data-id="element-1146">
                Transparent Background
              </h3>
            </div>
            <div className="py-20 px-12 flex items-center justify-center" style={{
            backgroundImage: 'linear-gradient(45deg, #e2e8f0 25%, transparent 25%), linear-gradient(-45deg, #e2e8f0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e2e8f0 75%), linear-gradient(-45deg, transparent 75%, #e2e8f0 75%)',
            backgroundSize: '20px 20px',
            backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px'
          }} data-id="element-1147">
              <div className="flex items-center" data-id="element-1148">
                <span className="text-7xl sm:text-8xl md:text-9xl font-semibold text-slate-800 tracking-tight lowercase leading-none" data-id="element-1149">
                  swedenmark
                </span>
                <div className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 mx-3 sm:mx-4 translate-y-[12%]" data-id="element-1150"></div>
                <span className="text-7xl sm:text-8xl md:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 lowercase leading-none" data-id="element-1151">
                  ai
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ---- #6 Domain Style with Gradient: Transparent Background ---- */}

        <div className="mb-16" data-id="element-1152">
          <div className="text-center mb-6" data-id="element-1153">
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1154">
              #6 Variant — Domain Style with Gradient (Transparent)
            </h2>
            <p className="text-sm text-slate-500 mt-1" data-id="element-1155">
              ".ai" in blue-to-purple gradient on transparent background
            </p>
          </div>
          <div className="rounded-2xl shadow-md border border-slate-200 overflow-hidden" data-id="element-1156">
            <div className="py-24 px-12 flex items-center justify-center" style={{
            backgroundImage: 'linear-gradient(45deg, #e2e8f0 25%, transparent 25%), linear-gradient(-45deg, #e2e8f0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e2e8f0 75%), linear-gradient(-45deg, transparent 75%, #e2e8f0 75%)',
            backgroundSize: '20px 20px',
            backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px'
          }} data-id="element-1157">
              <div className="flex items-baseline" data-id="element-1158">
                <span className="text-7xl sm:text-8xl md:text-9xl font-bold text-slate-800 tracking-tight lowercase leading-none" data-id="element-1159">
                  swedenmark
                </span>
                <span className="text-7xl sm:text-8xl md:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 lowercase leading-none" data-id="element-1160">
                  .ai
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}